
import { date } from '../../../lib/helpers';
import headers from './attributes';

export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    headers,
    selectedRow: '',
  }),
  computed: {
    flashErrorMessage() {
      return this.$store.state.rbac.mappingWilayah.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.rbac.mappingWilayah.flashError;
      },
      set() {
        this.$store.commit('rbac/mappingWilayah/setFlashErrorMessage', '');
      },
    },
    loading() {
      return this.$store.state.rbac.mappingWilayah.loading;
    },
    users() {
      return this.$store.state.rbac.mappingWilayah.allMappings;
    },
    totalMappings() {
      return this.$store.state.rbac.mappingWilayah.totalMappings;
    },
    totalPage() {
      return this.$store.state.rbac.mappingWilayah.totalPage;
    },
    itemsMapping() {
      return this.$store.state.rbac.allMapping;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },
    viewItem(item, type) {
      this.$router.push(`/rbac-mapping-wilayah/${type}/view`);
      this.$store.commit('rbac/mappingWilayah/setDetailData', item);
    },

    clearSearch() {
      this.getData();
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    getData() {
      this.$store.commit('rbac/mappingWilayah/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('rbac/mappingWilayah/fetchMappings', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    exportItem() {},
  },
};